import {
  toast,
  Slide,
  cssTransition,
  ToastContainerProps,
} from 'react-toastify';

export const POPUP_NOTIFICATIONS_CONTAINER_ID =
  'POPUP_NOTIFICATIONS_CONTAINER_ID';
export const BASE_ALERTS_CONTAINER_ID = 'BASE_ALERTS_CONTAINER_ID';
export const APPROVED_ENTITY_CONTAINER_ID = 'APPROVED_ENTITY_CONTAINER_ID';

export const DEFAULT_TOAST_DURATION = 5000; // 5 seconds
export const DEFAULT_NOTIFICATIONS_COUNT_LIMIT = 4;
const APPROVED_ENTITIES_COUNT_LIMIT = 3;

export const ALERT_TOASTER_OPTIONS: ToastContainerProps = {
  className: 'alerts-container',
  toastClassName: 'alert-toast',
  newestOnTop: true,
  hideProgressBar: true,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
  draggable: false,
  closeOnClick: false,
  autoClose: false,
  transition: Slide,
  closeButton: false,
  icon: false,
  theme: 'light',
  position: toast.POSITION.TOP_CENTER,
};

const fadeAnimation = cssTransition({
  enter: 'animate__animated animate__fadeInDown',
  exit: 'animate__animated animate__fadeOut',
});

export const NOTIFICATION_TOASTER_OPTIONS: ToastContainerProps = {
  className: 'notifications-container',
  toastClassName: 'notification-toast',
  newestOnTop: true,
  hideProgressBar: true,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
  draggable: false,
  closeOnClick: false,
  autoClose: DEFAULT_TOAST_DURATION,
  closeButton: false,
  icon: false,
  theme: 'light',
  transition: fadeAnimation,
  position: toast.POSITION.TOP_RIGHT,
  limit: DEFAULT_NOTIFICATIONS_COUNT_LIMIT,
};

export const APPROVED_ENTITY_TOASTER_OPTIONS: ToastContainerProps = {
  className: 'approved-entity-container',
  toastClassName: 'approved-entity-toast',
  bodyClassName: 'approved-entity-toast-body',
  newestOnTop: true,
  hideProgressBar: true,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
  draggable: false,
  closeOnClick: false,
  autoClose: false,
  closeButton: false,
  icon: false,
  theme: 'light',
  transition: Slide,
  position: toast.POSITION.TOP_CENTER,
  limit: APPROVED_ENTITIES_COUNT_LIMIT,
};
